export const companyFileTypes = [
  '阿尔法认知',
  '职能模块认知',
  '公司简介',
  '薪酬/职级/奖金机制',
  '公司O-Chart',
  '客户会面',
  '特殊要求',
  '推荐模板',
  '开票信息',
  '竞标文件',
  '应聘登记表',
  '合同',
  '其他',
]
export const projectFileTypes = [
  '岗位JD',
  '岗位要求',
  '岗位职责',
  '寻访方向',
  '目标人选',
  '部门情况',
  '职位亮点及优势',
  '领导介绍',
  '薪资架构',
  '职位话术',
  '项目报告',
  '项目小结',
  '其他',
]
export const radishFileTypes = [
  '原始简历',
  '推荐报告',
  '背景调查',
  '薪资证明',
  '测评报告',
  '会面记录',
  '名片',
  '人选offer',
  '行研报告',
  '应聘登记表',
  '其他资料',
]
export const knowledgeFileTypes = ['行业知识', '职能模块', '出品报告', '市场动态', '薪酬报告']
export const knowledgeFileSubTypes = {
  行业知识: ['行业科普', '行业趋势', '行业热点', '行业八卦', '公司名录', '公司排名', '公司介绍', '领军人物'],
  职能模块: [
    '行业趋势',
    '行业八卦',
    '热点研究',
    '公司分类',
    '领军人物',
    '细分领域认知',
    '职能模块介绍',
    '答辩ppt',
    '职能模块培训',
  ],
  出品报告: ['行业报告', '年度报告', '年度薪酬报告', '其他增值报告'],
  薪酬报告: ['薪酬报告', '数据分析'],
  市场动态: ['大佬流动', '业务八卦', '爆雷', '业务趋势', '业务热点', '监管政策'],
}
